import { useState, useEffect } from 'preact/hooks';

type OrientationType = 'portrait' | 'landscape';

/**
 * Hook check current device orientation
 * @returns current device orientation, 'portrait'(portrait) or 'landscape'(landscape)
 */
export function useOrientation(): OrientationType {
  const getOrientation = (): OrientationType => {
    if (typeof window === 'undefined') {
      return 'portrait';
    }

    if (window.matchMedia('(orientation: landscape)').matches) {
      return 'landscape';
    }
    return 'portrait';
  };

  const [orientation, setOrientation] = useState<OrientationType>(getOrientation());

  useEffect(() => {
    const updateOrientation = () => {
      setOrientation(getOrientation());
    };

    window.addEventListener('resize', updateOrientation);

    if ('onorientationchange' in window) {
      window.addEventListener('orientationchange', updateOrientation);
    }

    updateOrientation();

    return () => {
      window.removeEventListener('resize', updateOrientation);
      if ('onorientationchange' in window) {
        window.removeEventListener('orientationchange', updateOrientation);
      }
    };
  }, []);

  return orientation;
}
